import styles from '@components/DevToolbar/DevToolbarTab/DevToolbarTabHeader/DevToolbarTabHeader.styles';
import commonStyles from '@components/DevToolbar/DevToolbarTab/common.styles';
import Heading from '@components/Heading/Heading';
import { BASE_PATH } from '@config/index';
import Button from '@components/Button/Button';
import Icon from '@components/icons/Icon';
import getPublicEnv from '@utils/getPublicEnv';
import { useCartStore } from '@features/cart/mobx/context/CartStoreProvider';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
import { useTranslation } from 'next-i18next';
type PropsType = {
  name: string;
};
const DevToolbarTabHeader = ({
  name
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const {
    cartId
  } = useCartStore();
  const copyUrl = () => {
    void navigator.clipboard.writeText(window.location.href);
  };
  const copyCartId = () => {
    if (cartId) {
      void navigator.clipboard.writeText(cartId);
    }
  };
  return <>
      <div sx={styles.headerWrapper}>
        <ResponsiveImage image={`${BASE_PATH}/img/logo.svg`} alt={t('logoIconAlt')} width={39} height={29} priority />
        <div sx={commonStyles.badges}>
          <div sx={commonStyles.badge(false)}>
            <div sx={commonStyles.badgeIcon}>
              <Icon icon="Download" size="16px" color="white" />
            </div>
            <b>{getPublicEnv('NEXT_PUBLIC_SERVICE_VERSION')}</b>
          </div>
          <div sx={commonStyles.badge(false)}>
            <div sx={commonStyles.badgeIcon}>
              <Icon icon="Visibility" size="16px" color="white" />
            </div>
            <b>{getPublicEnv('NEXT_PUBLIC_SERVICE_INSTANCE')}</b>
          </div>
          <div sx={commonStyles.badge(false)}>
            <div sx={commonStyles.badgeIcon}>
              <Icon icon="ShoppingCart" size="16px" color="white" />
            </div>
            <b>{cartId || 'No cart generated'}</b>

            {cartId && <Button addSx={styles.copyButton} variant="iconOnly" variantColor="white" size="small" onClick={copyCartId}>
                <Icon icon="Copy" size="16px" />
              </Button>}
          </div>
        </div>
        <Button addSx={styles.copyButton} variant="outlined" variantColor="white" size="small" onClick={copyUrl}>
          Copy URL <Icon icon="Copy" size="16px" />
        </Button>
      </div>
      <Heading h={4} headingType={4} pb={24} bold align="center" color="white">
        {name}
      </Heading>
    </>;
};
export default DevToolbarTabHeader;